export default "__VITE_ASSET__y355FsO8__"